import { V2Alert } from '@abyss/web/ui/Alert';
import { find } from 'lodash';
import React from 'react';

import { useLagoon } from '../../hooks/useLagoon';
import { ConstantsLagoon } from '../ConstantsLagoon';

const testId = 'laww-sign-in-banner-alert';

export const LawwSignInAlert: React.FC = () => {
  const getUiMessaging = useLagoon('ui-messaging') as () => Array<{
    key?: string;
    message?: string;
    url?: string;
  }>;
  const lagoonUIMessage = getUiMessaging();
  const signInMsg = find(lagoonUIMessage, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.SIGN_IN_ALERT_MESSAGE,
  })?.message;
  const signInHeader = find(lagoonUIMessage, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.SIGN_IN_ALERT_HEADER,
  })?.message;
  const signInURL = find(lagoonUIMessage, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.SIGN_IN_ALERT_URL,
  })?.url;
  const signInButtonMsg = find(lagoonUIMessage, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.SIGN_IN_ALERT_URL,
  })?.message;
  const resolvedSignInMsg = signInMsg || '';
  const resolvedSignInHeader = signInHeader || '';
  const resolvedSignInURL = signInURL || '';
  return (
    <>
      <style>
        {`.laww-signin-alert.abyss-alert-root {
            width: 100% !important;
          }
          .laww-signin-alert.abyss-alert-wrapper {
            max-width: 1200px !important;
          }
          .laww-signin-alert .abyss-alert-root,
          .laww-signin-alert.abyss-alert-root {
      background-color: rgba(176, 227, 234, 1) !important;
          }
          .laww-signin-alert .abyss-alert-icon {
            width: 48px !important;
            height: 48px !important;
            min-width: 48px !important;
            border-radius: 50% !important;
            background-color: rgba(25, 110, 207, 1) !important;
            color: #ffffff !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
          .laww-signin-alert .abyss-alert-icon .abyss-icon-symbol { color: #ffffff !important; fill: #ffffff !important; }`}
      </style>
      <V2Alert
        className="laww-signin-alert"
        cta={{
          type: 'button',

          props: {
            children: signInButtonMsg,
            onClick: () => {
              if (!resolvedSignInURL) {
                // eslint-disable-next-line no-console
                console.error('No sign in url provided');
                return;
              }
              if (!resolvedSignInURL.startsWith('https://')) {
                // eslint-disable-next-line no-console
                console.error('Invalid sign in url:', resolvedSignInURL);
                return;
              }
              try {
                // Navigate the top-level portal window (liveandworkwell.com) out of
                // the cross-origin iframe. Browsers allow cross-origin writes to
                // window.top.location for navigation.
                window.top?.location.assign(resolvedSignInURL);
              } catch (e) {
                // eslint-disable-next-line no-console
                console.error('Failed to navigate to sign in page:', e);
              }
            },
          },
        }}
        data-testid={testId}
        dismissible={false}
        onClose={() => {}}
        showDivider={false}
        status="info"
        title={resolvedSignInHeader}
      >
        {resolvedSignInMsg}
      </V2Alert>
    </>
  );
};
